import { Action, combineReducers } from '@reduxjs/toolkit';

import { DemandTopicsReducerState, demandsTopicsReducer } from '../demands-topics/store/demands-topics-reducers';
import { DemandsDetailReducerState, demandsDetailReducer } from '../demands-detail/store/demands-detail-reducers';
import {
    DemandsOverviewReducerState,
    demandsOverviewReducer,
} from '../demands-overview/store/demands-overview-reducers';

export interface DemandsReducerState {
    overview: DemandsOverviewReducerState;
    detail: DemandsDetailReducerState;
    topics: DemandTopicsReducerState;
}

const combinedDemandsReducer = combineReducers<DemandsReducerState>({
    overview: demandsOverviewReducer,
    detail: demandsDetailReducer,
    topics: demandsTopicsReducer,
});

const initialDemandsReducerState: DemandsReducerState = combinedDemandsReducer(undefined, {
    type: '',
});

export const demandsReducer = (
    state: DemandsReducerState = initialDemandsReducerState,
    action: Action
): DemandsReducerState => {
    switch (action.type) {
        /*         case DEMANDS_RESET:
            return combinedDemandsReducer(undefined, action); */
        default:
            return combinedDemandsReducer(state, action);
    }
};
